import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from '../../../services/general.service';
import {Injectable} from '@angular/core';
import {IWhatsNew} from '../interfaces/IWhatsNew';
import {Page} from '../../../model/page';

@Injectable()
export class WhatsNewService extends GeneralService {

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    getById(id): Observable<any> {

        if (id === 0) {
            return Observable.of(this.initialize());
        }

        const url = `${this.apiUrl}/whats-new/view`;
        return this.http.get(url, {params: {WN1_ID: id}});
    }

    save(whatsNew: IWhatsNew, isCreate: boolean): Observable<any> {
        return isCreate ? this.create(whatsNew) : this.update(whatsNew);
    }

    delete(whatsNew: any): Observable<any> {
        const url = `${this.apiUrl}/whats-new/delete`;
        return this.http.post(url, whatsNew);
    }

    private create(whatsNew: IWhatsNew): Observable<any> {
        const url = `${this.apiUrl}/whats-new/create`;
        return this.http.post(url, whatsNew);
    }

    private update(whatsNew: IWhatsNew): Observable<any> {
        const url = `${this.apiUrl}/whats-new/update`;
        return this.http.put(url, whatsNew);
    }

    public getDataList(page: Page): Observable<any> {
        const url = '/whats-new/index';
        return this.getRestList(page, url);
    }

    public initialize() {
        return {
            WN1_ID: null,
            WN1_VERSION: null,
            WN1_RELEASE_DATE: null,
            WN1_STATUS: null,
            WN1_EDI_PORTAL_TITLE: null,
            WN1_EDI_PORTAL_TEXT: null,
            WN1_SUPPLIER_GATEWAY_TITLE: null,
            WN1_SUPPLIER_GATEWAY_TEXT: null,
            WN1_CUSTOMER_GATEWAY_TITLE: null,
            WN1_CUSTOMER_GATEWAY_TEXT: null,
            WN1_CONFIG_SETUP_TITLE: null,
            WN1_CONFIG_SETUP_TEXT: null,
            WN1_CREATED_ON: null,
            WN1_CREATED_BY: null,
            WN1_MODIFIED_ON: null,
            WN1_MODIFIED_BY: null,
            WN1_DELETE_FLAG: null,
            WN1_UPDATE_FLAG: null
        };
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/whatsnew/services/whatsnew.service.ts